import React, { useContext } from 'react';
import { StyleSheet, View } from 'react-native';
import PropTypes from 'prop-types';
import SocialLink from './SocialLink';
import Button from '../common/Button';
import { H3 } from '../text';
import LayoutContext from '../../contexts/Layout';

const SocialLinksContainerWithCta = ({
    buttonBackgroundColor,
    buttonText,
    contentItems,
    followContentLink,
    heading,
    link,
    nodeTypeAlias = 'SocialLinksContainerWithCta',
    references
}) => {
    const { layout } = useContext(LayoutContext);

    const renderSocialLinks = () => {
        return (
            <View style={Styles.socialLinksContainer}>
                {Object.values(contentItems).map(child => {
                    let type = child?.socialMediaType;
                    let color = '#000';

                    if (type.indexOf('twitter') !== -1) {
                        type = 'x-twitter';
                    }

                    switch (type.toLowerCase()) {
                        case 'facebook':
                            color = '#3c5a99';
                            break;
                        case 'instagram':
                            color = '#800080';
                            break;
                        case 'youtube':
                            color = '#ff0000';
                            break;
                        default:
                            break;
                    }

                    return (
                        <View
                            key={child.id}
                            style={{ marginRight: Math.floor(layout.styleGuide.spacer2 * 2) }}
                            dataSet={{ spacerRight: `StyleGuide.Spacer2*2(${Math.floor(layout.styleGuide.spacer2 * 2)})` }}
                        >
                            <SocialLink
                                iconStyle={{ color }}
                                link={child.socialMediaLink}
                                nodeTypeAlias={child.nodeTypeAlias}
                                size={layout.device.os.equals('web') ? '34pt' : 34}
                                type={type.toLowerCase()}
                            />
                        </View>
                    );
                })}
            </View>
        );
    };

    if (!contentItems || Object.keys(contentItems).length === 0) {
        return null;
    }

    return (
        <View style={Styles.wrapper} dataSet={{ umbracoComponentName: nodeTypeAlias }}>
            <View style={{ alignItems: 'center', justifyContent: 'center' }}>
                {!!heading && (
                    <H3
                        dataSet={{ spacerBottom: `SpacerBottom.Spacer2(${layout.styleGuide.spacer2})` }}
                        style={{ color: '#8897a2', marginBottom: layout.styleGuide.spacer2 }}
                        text={heading}
                    />
                )}
                {renderSocialLinks()}
                {!!buttonText && (
                    <Button
                        onPress={async () => followContentLink && (await followContentLink(link.isExternal, link.internalKey, link.externalUrl, references))}
                        style={{ backgroundColor: buttonBackgroundColor }}
                        text={buttonText}
                        textStyle={{ color: '#fff' }}
                    />
                )}
            </View>
        </View>
    );
};

const Styles = StyleSheet.create({
    optionalCtaButtonContainer: {
        flexDirection: 'row',
        justifyContent: 'center'
    },
    socialLinksContainer: {
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'center',
        marginBottom: 4
    },
    wrapper: {
        alignSelf: undefined
    }
});

SocialLinksContainerWithCta.propTypes = {
    buttonText: PropTypes.string,
    buttonBackgroundColor: PropTypes.string,
    contentItems: PropTypes.shape({
        id: PropTypes.string,
        socialMediaLink: PropTypes.string,
        socialMediaType: PropTypes.string
    }),
    heading: PropTypes.string,
    link: PropTypes.shape({
        externalUrl: PropTypes.string,
        internalKey: PropTypes.string,
        isExternal: PropTypes.bool
    })
};

export default SocialLinksContainerWithCta;
